export default __webpack_public_path__ + "static/media/partner.ac960e2b.svg";